import { createSelector } from '@reduxjs/toolkit';

import { getActiveComponentDesignGuid } from './getActiveComponentDesignSelector';
import { ComponentSpans, getComponentSpans } from './getComponentSpansSelector';

export const getActiveComponentSpans = createSelector(
  getActiveComponentDesignGuid,
  getComponentSpans,

  (activeComponentDesignGuid, componentSpans): ComponentSpans | null =>
    activeComponentDesignGuid == null ? null : componentSpans[activeComponentDesignGuid],
);
